import {FormModalProps} from "../../utils/useFormModal";
import {Col, Form, Modal, Row, Select as AntSelect, Switch} from "antd";
import Select from "../../components/Select";
import BaseDataSelect from "../../components/BaseDataSelect";
import * as instrumentApi from "../../apis/platforms/admin/placingInstruments";
import DictSelect from "../../components/DictSelect";
import {useWatch} from "antd/lib/form/Form";
import {useRequest} from "ahooks";
import {useEffect, useState} from "react";

function DuplicateModal(props: FormModalProps) {

    const {form, ...otherProps} = props;
    const contractType = useWatch('contractType', form);
    const dealerId = useWatch('dealerId', form);
    const isTerminal = useWatch('isTerminal', form);
    const hospitalId = useWatch('hospitalId', form);
    const instrumentId = useWatch('instrumentId', form);
    const [hospitalOption, setHospitalOption] = useState<any[]>([]);
    const [instrumentOption, setInstrumentOption] = useState<any[]>([]);

    const {loading: loadingGetHospitals, runAsync: runGetHospitals} = useRequest(instrumentApi.getHospitalByDealer, {
        manual: true,
        onSuccess(res){
            setHospitalOption(res?.data?.data || []);
            if(!res?.data?.data?.some((hospital:any)=>hospital.hospitalId == hospitalId)){
                form.setFieldValue('hospitalId', null);
                form.setFieldValue('instrumentId', null);
            }
        }
    });
    const {loading: loadingGetInstruments, runAsync: runGetInstruments} = useRequest(instrumentApi.getInstrumentsByHospitalAndDealer, {
        manual: true,
        onSuccess(res){
            setInstrumentOption(res?.data?.data || []);
            if(!res?.data?.data?.some((instrument:any)=>instrument.id == instrumentId)){
                form.setFieldValue('instrumentId', null);
            }
        }
    });

    useEffect(() => {
        if(!dealerId){
            setHospitalOption([]);
        }else{
            runGetHospitals(dealerId);
        }
    }, [dealerId]);
    useEffect(() => {
        if(!hospitalId || !dealerId){
            setInstrumentOption([]);
        }else{
            runGetInstruments(hospitalId, dealerId);
        }
    }, [dealerId, hospitalId]);

    return (
        <Modal width={1000} {...otherProps}>
            <Form form={form} layout={"vertical"}>
                <Form.Item noStyle hidden name={"id"}/>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item name={'contractType'} label={'客户类型'}>
                            <DictSelect dict={'ContractType'} appendNull={false}/>
                        </Form.Item>
                    </Col>
                    {contractType == 'group-contract' &&
                        <Col span={8}>
                            <Form.Item name={'groupId'} label={'集团'} rules={[{required: true}]}>
                                <BaseDataSelect name={'groups'}/>
                            </Form.Item>
                        </Col>}
                    {contractType == 'dealer-contract' &&
                        <Col span={8}>
                            <Form.Item name={'dealerId'} label={'客户'} rules={[{required: true}]}>
                                <Select url={'/dealer/dict'} getData={data => data.data} textField={'name'}/>
                            </Form.Item>
                        </Col>}
                    {contractType == 'dealer-contract' &&
                        <Col span={8}>
                            <Form.Item name={'isTerminal'} label={'是否终端'} valuePropName={'checked'}>
                                <Switch/>
                            </Form.Item>
                        </Col>}
                    {contractType == 'dealer-contract' && isTerminal &&
                        <>
                            <Col span={8}>
                                <Form.Item name={'hospitalId'} label={'终端医院'} rules={[{required: true}]}>
                                    <AntSelect loading={loadingGetHospitals} options={hospitalOption} fieldNames={{value: 'hospitalId', label: 'hospitalName'}}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={'instrumentId'} label={'投放仪器'} rules={[{required: true}]}>
                                    <AntSelect loading={loadingGetInstruments} options={instrumentOption} fieldNames={{value: 'id', label: 'specificationAndModel'}}/>
                                </Form.Item>
                            </Col>
                        </>
                    }
                </Row>
            </Form>
        </Modal>
    )
}

export default DuplicateModal;